module.exports = __webpack_public_path__ + "static/media/speakers_logos_CIBSE.f41678cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_CIBSE.jpg
// module id = 117
// module chunks = 0